// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/advices.scss'

// Real Estate Programs Search Form
async function getREPSForm ($f) {
  $f.load()
  import(/* webpackChunkName: "realEstateProgramsSearchForm" */ './js/components/realEstateProgramsSearchForm.js').then(() => {
    $f.load(false)
  })
}

// MagnificPopup
async function getMagnificPopup () {
  import(/* webpackChunkName: "magnificPopup" */ './js/components/magnificPopup.js')
}

// Contact Form
async function getContactForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    $f.load(false)
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion du formulaire de recherche rapide des programmes
  const $e = $('.rep-search-form.in')
  if ($e.length) {
    $e.waypoint(function () {
      getREPSForm($e)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion image popup
  const $i = $('.image-popup-gallery, .image-popup-only')
  if ($i.length) {
    $i.waypoint(function () {
      getMagnificPopup()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $f = $('.contact-form')
  if ($f.length) {
    $f.waypoint(function () {
      getContactForm($f)
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
